import { Component, computed, inject, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavController } from '@ionic/angular/standalone';
import C2U from '@chemist2u/types-client';
import { CustomerScript } from '@chemist2u/types-client/C2U/ParseObjects';
import { AmplitudeService } from 'src/app/services/amplitude.service';

type TStatusLabel = "Valid" | "Cancelled" | "Dispensed" | "Expired" | "Disabled";
type TStatusClass = "green" | "blue" | "red" | "black";

@Component({
    selector: 'app-script-card',
    templateUrl: './script-card.component.html',
    styleUrls: ['./script-card.component.scss'],
    imports: [CommonModule]
})
export class ScriptCardComponent {
  private $amplitude = inject(AmplitudeService);
  private navCtrl = inject(NavController);

  public script = input.required<CustomerScript>();

  public status = computed<{ class: TStatusClass, label: TStatusLabel }>(() => {
    const statuses: { class: TStatusClass, label: TStatusLabel }[] = [
      { class: "green", label: "Valid" },
      { class: "red", label: "Cancelled" },
      { class: "black", label: "Dispensed" },
      { class: "blue", label: "Expired" },
      { class: "black", label: "Disabled" },
    ];
    return statuses.filter(s => s.label == this.script()?.status)[0] || statuses[0];
  });
  
  goToScript() {
    this.$amplitude.track('SCRIPT_DETAILS_CLICKED', {
      origin: "MyScripts",
      content: "Script Details",
      UI: "Script_Card",
    });
    this.navCtrl.navigateForward([`/view-script/${this.script().id}`]);
  }
}